import { motion } from "framer-motion";
import { X } from "lucide-react";

export const ContentsDrawer = ({ pages, edition, ui, current, onGo, onClose }) => {
  const toc = pages.find((p) => p.template === "contents")?.toc || [];
  return (
    <motion.div className="drawer" initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }} transition={{ type: "spring", damping: 26, stiffness: 220 }} data-testid="contents-drawer">
      <div className="max-w-6xl mx-auto px-6 py-6">
        <div className="flex items-center justify-between mb-5">
          <div className="reader-label" style={{ color: "#fff" }}>{ui.contents} · {edition?.number}</div>
          <button className="reader-btn" onClick={onClose} title={ui.close} data-testid="btn-close-contents"><X size={18} /></button>
        </div>
        <div className="grid gap-3" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))" }}>
          {toc.map((t) => (
            <button key={t.page} className="tile text-left" onClick={() => onGo(t.page)} style={{ background: "#232323", border: "1px solid rgba(217,218,221,0.1)" }} data-testid={`drawer-section-${t.page}`}>
              <div style={{ height: 110, overflow: "hidden", background: "var(--bordeaux)" }}>
                {t.image && <img src={t.image} alt={t.label} className="w-full h-full object-cover" />}
              </div>
              <div className="p-3">
                <div className="reader-label" style={{ color: "var(--platinum)" }}>{String(t.page).padStart(2, "0")}</div>
                <div className="font-head font-semibold text-white" style={{ fontSize: 18, lineHeight: 1 }}>{t.label}</div>
                <div className="font-head italic" style={{ fontSize: 13, opacity: 0.6 }}>{t.section}</div>
              </div>
            </button>
          ))}
        </div>
        <div className="silver-rule my-6" style={{ opacity: 0.4 }} />
        <div className="flex flex-wrap gap-1.5" data-testid="page-strip">
          {pages.map((p) => (
            <button key={p.n} className={`page-chip ${current.includes(p.n) ? "on" : ""}`} onClick={() => onGo(p.n)} title={p.title} data-testid={`page-chip-${p.n}`}>{p.n}</button>
          ))}
        </div>
      </div>
    </motion.div>
  );
};
